import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import Menu_Items from '../Menu_Items';
import { GrDocumentConfig } from "react-icons/gr";
import { FcDataConfiguration } from "react-icons/fc";
import { BiSolidSelectMultiple } from "react-icons/bi";
import { VscOutput } from "react-icons/vsc";
import { IoClose } from "react-icons/io5";
import { TbTransformFilled } from "react-icons/tb";
import { FaCaretUp, FaCaretDown } from "react-icons/fa";



function Config() {

  const { id, int_id, Ex_id } = useParams();

  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [monitor, setmonitor] = useState(false);

  const [draggedIndex, setDraggedIndex] = useState(null);

  const [Showconfig, setShowconfig] = useState(true);
  const [ShowHeaders, setShowHeaders] = useState(false);
  const [ShowFields, setShowFields] = useState(false)
  const [Showvalue, setShowvalue] = useState(0)

  const [Headers, setHeaders] = useState([]);
  const [Tables, setTables] = useState([]);
  const [Config, setConfig] = useState({});

  const [fields, setfields] = useState([]);
  const [selectedfields, setselectedfields] = useState({});
  const [selectedfieldIds, setselectedfieldIds] = useState([]);
  const [valueids, setvalueids] = useState([]);
  const [value, setvalue] = useState([]);
  const [outputfields, setoutputfields] = useState([]);
  const [HeaderMapping, setHeaderMapping] = useState({});
  const [ValueMapping, setValueMapping] = useState({});



  const menus = [
    {
      name: 'Integrations',
      id,
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'Out Bound', id, int_id, Ex_id },
      { name: 'Conditions', id, int_id, Ex_id },
      { name: 'Linked Tables', id, int_id, Ex_id },
      { name: 'Config', id, int_id, Ex_id },
      { name: 'Result', id, int_id, Ex_id },
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
    else {
      setmonitor(true)
    }

  };
  const getOutBound = async () => {
    await axios.get(`/out_bound/export_value/${Ex_id}`).then(res => {
      const Response = res.data;
      const data = {};
      if (Response.Headers) {
        const headers = JSON.parse(Response.Headers);
        headers.forEach(element => {
          const key = Object.keys(element);
          const value = Object.values(element);
          data[key] = value
        });
        const tables = Object.keys(data)
        tables.forEach(name => {
          const tableheaders = data[name].flat().map(obj => obj.alias)
          data[name] = tableheaders
        });
        setTables(tables)
        setHeaders(data);
        if (Response.Config && Response.Output) {
          const config = JSON.parse(Response.Config)
          setConfig(config);
          if (tables.includes(config.Fields)) {
            getfields(config.Fields)
          }
          const Output = JSON.parse(Response.Output);
          const { selectedfields, outputfields } = Output
          setoutputfields(outputfields);
          setselectedfields(selectedfields);
          const ids = Object.values(selectedfields);
          setselectedfieldIds(ids);
          getValues(config, ids)
        }
        else if (Response.Config) {
          const config = JSON.parse(Response.Config)
          setConfig(config);
          if (tables.includes(config.Fields)) {
            getfields(config.Fields)
          }
        }
        else if (Response.Output) {
          const Output = JSON.parse(Response.Output);
          const { selectedfields, outputfields } = Output
          setoutputfields(outputfields);
          setselectedfields(selectedfields);
          const ids = Object.values(selectedfields);
          setselectedfieldIds(ids)
        }
        if (Response.Result_Mapping) {
          const Result_Mapping = JSON.parse(Response.Result_Mapping);
          const { HeaderMapping, ValueMapping } = Result_Mapping;
          setHeaderMapping(HeaderMapping);
          setValueMapping(ValueMapping)
          // console.log(Result_Mapping);
        }
      }
      // getValues()

    }).catch((err) => {
      toast.error("get out_bound error", {
        autoClose: 2000, // 2 seconds
      });
    });
  };
  const handleconfig = (key, val) => {
    setConfig(prev => ({ ...prev, [key]: val }))
  };
  const handleCheckboxHeader = (key, val1) => {
    if (selectedfieldIds.includes(val1)) {
      const { [key]: _, ...rest } = selectedfields;
      setselectedfields(rest);
      setselectedfieldIds(prev => prev.filter(val => val !== val1));
    } else {
      setselectedfields(prev => ({ ...prev, [key]: val1 }));
      setselectedfieldIds(prev => ([...prev, val1]));
    }
  };
  const handleheaderMapping = (key, val) => {
    setHeaderMapping(prev => ({ ...prev, [key]: val }));
  };
  const handleValueMapping = (key1, key2, val) => {
    setValueMapping(prev => ({ ...prev, [key1]: { ...prev[key1], [key2]: val } }));
  };
  const getheaders = (key) => {
    const table = Config[key];
    if (table) {
      return Headers[table]
    }
    return []
  };
  const getheadername = (key) => {
    const convertkeytoval = Object.fromEntries(
      Object.entries(selectedfields).map(([key, value]) => [value, key])
    );
    // console.log(123, key);
    return convertkeytoval[key]
  };
  const getheadervalue = (key) => {
    const { Primary_O, Value_O } = Config;
    const data = value.filter(obj => obj[Primary_O] === key).map(val => val[Value_O]);
    // console.log(value);
    return data;
  };
  const getfields = async (name) => {
    await axios.get(`/out_bound/field/value/${name}/${int_id}/${Ex_id}`).then((res) => {
      const values = res.data;
      setfields(values[name]);
      // console.log(values);
    })
      .catch((err) => {
        toast.error("Fields Fetched Error", {
          autoClose: 2000, // 2 seconds
        });
      });
  };
  const submit = async () => {
    if (Tables.includes(Config.Fields)) {
      getfields(Config.Fields)
    }
    const data = {
      Config: JSON.stringify(Config)
    }
    await axios.patch(`/out_bound/Config/${Ex_id}`, data).then((res) => {
      submitfields()
    }).catch((err) => {
      toast.error("out_bound Result Mapping update error", {
        autoClose: 2000, // 2 seconds
      })
    })

  };
  const handleConfig = () => {
    if (Tables.includes(Config.Fields)) {
      getfields(Config.Fields)
    }
    setShowHeaders(true)
  };
  const submitmapping = async () => {
    const data1 = {
      HeaderMapping,
      ValueMapping
    }
    const data = {
      Result_Mapping: JSON.stringify(data1)
    };
    await axios.patch(`/out_bound/ResultMapping/${Ex_id}`, data).then((res) => {
      // console.log(res.data);
      // Showconfig(false);
    }).catch((err) => {
      toast.error("out_bound Result Mapping update error", {
        autoClose: 2000, // 2 seconds
      })
    })
    // console.log(data);
  };
  const getValues = async (val1, val2) => {
    const { Option, Primary_O } = val1
    const data = {
      table: Option,
      field: Primary_O,
      ids: val2
    };

    await axios.post(`/out_bound/value/${Ex_id}`, data).then((res) => {
      const data = res.data[Option];
      const data1 = [...new Set(data.map(obj => obj[Primary_O]))];
      setvalueids(data1.filter(Boolean));
      setvalue(data);
    }).catch((err) => {
      toast.error("out_bound Result Mapping update error", {
        autoClose: 2000, // 2 seconds
      })
    })

  };
  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const Headername = Config.Value_F;
      const connectname = Config.Primary_F;
      let data = {}
      fields.forEach(obj => {
        data[obj[Headername]] = obj[connectname]
      });
      setselectedfields(data);
      setselectedfieldIds(fields.map(obj => obj[connectname]));
    } else {
      setselectedfieldIds([]);
      setselectedfields({});
    }
  };
  const allSelected = () => {
    return fields.length === selectedfieldIds.length;
  };
  const getoutputfields = () => {
    if (Config.Main) {
      let data = [Headers[Config.Main]];
      const newfields = Object.keys(selectedfields);
      data = [...data, newfields].flat();
      setoutputfields(data)
    } else {
      setoutputfields([])
    }
  };
  const submitfields = async () => {
    // 
    // console.log(fields.length === selectedfieldIds.length);
    const data = {
      Output: JSON.stringify({
        selectedfields,
        outputfields
      })
    };
    await axios.patch(`/out_bound/Output/${Ex_id}`, data).then((res) => {
      // console.log(res.data);
      getValues(Config, selectedfieldIds);
      setShowFields(false);
    }).catch((err) => {
      toast.error("out_bound Result Mapping update error", {
        autoClose: 2000, // 2 seconds
      })
    })
  };
  // Start dragging
  const onDragStart = (e, field, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };
  // Allow drop
  const onDragOver = (e) => {
    e.preventDefault();
  };
  // Drop and reorder
  const onDrop = (e, field, dropIndex) => {
    e.preventDefault();
    if (draggedIndex === null) return;

    const newFields = [...outputfields];
    const draggedItem = newFields[draggedIndex];

    // Remove from old position
    newFields.splice(draggedIndex, 1);
    // Insert at new position
    newFields.splice(dropIndex, 0, draggedItem);

    setoutputfields(newFields);
    setDraggedIndex(null);
  };
  // Remove field
  const removeField = (index) => {
    setoutputfields(outputfields.filter((_, i) => i !== index));
    const data = outputfields.find((_, i) => i === index);
    const { [data]: _, ...rest } = selectedfields
    setselectedfields(rest);
    setselectedfieldIds(prev => prev.filter(val => val !== selectedfields[data]));
    // console.log(selectedfields[data]);
  };
  const findoptions = () => {
    setvalueids(prev => prev.filter(fids => selectedfieldIds.includes(fids)))
  }
  useEffect(() => {
    get_level();
    getOutBound();
  }, []);
  return (
    <div className='container df fdc jb ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac of_h'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'>
              <GrDocumentConfig className='page_icon db' />
              <p>Config</p>
            </div>
            <div className='h5 w10 df jc ac'>
              <BiSolidSelectMultiple className='h3 w30 g' onClick={() => { setShowHeaders(true) }} />
              <VscOutput className='h2 w20 g' onClick={() => { setShowFields(true); getoutputfields() }} />
              {
                outputfields.length > 0 && <TbTransformFilled className='h2 w20 g' onClick={() => { setShowconfig(!Showconfig); findoptions() }} />
              }
            </div>
          </div>
          <div className='h75 w100 white'>
            {
              Showconfig ? <div className='m1 h50 w50 df fdc fw '>
                <div className='h8 w40 df fdc je'>
                  <label>Main Table</label>
                  <select className='h4' onChange={(e) => handleconfig('Main', e.target.value)} value={Config.Main || ''}>
                    <option value={''}>Select Table</option>
                    {
                      Tables.length > 0 && Tables.map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Primary Header</label>
                  <select className='h4' onChange={(e) => handleconfig('Primary', e.target.value)} value={Config.Primary || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('Main').length > 0 && getheaders('Main').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Dynamic Value Table</label>
                  <select className='h4' onChange={(e) => handleconfig('D_value', e.target.value)} value={Config.D_value || ''}>
                    <option value={''}>Select Table</option>
                    {
                      Tables.length > 0 && Tables.map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Primary Header (Main)</label>
                  <select className='h4' onChange={(e) => handleconfig('Primary_M', e.target.value)} value={Config.Primary_M || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('D_value').length > 0 && getheaders('D_value').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Primary Header</label>
                  <select className='h4' onChange={(e) => handleconfig('Primary_D', e.target.value)} value={Config.Primary_D || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('D_value').length > 0 && getheaders('D_value').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Value Header</label>
                  <select className='h4' onChange={(e) => handleconfig('Value_D', e.target.value)} value={Config.Value_D || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('D_value').length > 0 && getheaders('D_value').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Field Table</label>
                  <select className='h4' onChange={(e) => handleconfig('Fields', e.target.value)} value={Config.Fields || ''}>
                    <option value={''}>Select Table</option>
                    {
                      Tables.length > 0 && Tables.map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Primary Header</label>
                  <select className='h4' onChange={(e) => handleconfig('Primary_F', e.target.value)} value={Config.Primary_F || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('Fields').length > 0 && getheaders('Fields').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Value Header</label>
                  <select className='h4' onChange={(e) => handleconfig('Value_F', e.target.value)} value={Config.Value_F || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('Fields').length > 0 && getheaders('Fields').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Option Value Table</label>
                  <select className='h4' onChange={(e) => handleconfig('Option', e.target.value)} value={Config.Option || ''}>
                    <option value={''}>Select Table</option>
                    {
                      Tables.length > 0 && Tables.map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Primary Header</label>
                  <select className='h4' onChange={(e) => handleconfig('Primary_O', e.target.value)} value={Config.Primary_O || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('Option').length > 0 && getheaders('Option').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
                <div className='h8 w40 df fdc je'>
                  <label>Value Header</label>
                  <select className='h4' onChange={(e) => handleconfig('Value_O', e.target.value)} value={Config.Value_O || ''}>
                    <option value={''}>Select Header</option>
                    {
                      getheaders('Option').length > 0 && getheaders('Option').map((name, index) => (<option value={name} key={index}>{name}</option>))
                    }
                  </select>
                </div>
              </div>
                :
                <div className='m1 h75 w100 df jb white'>
                  <div className='h75 w20 b0100'>
                    <div className='h5 w100 df jc ac'>
                      <label>Headers Mapping</label>
                    </div>
                    <div className='h65 w100 df fdc gap of_a'>
                      {
                        outputfields.length > 0 && outputfields.map((head, index) => (
                          <div className='h7 w100 df fdc' key={index}>
                            <label>{head}</label>
                            <input className='h3 w90 b1 padleft' value={(HeaderMapping && HeaderMapping[head]) || ''} onChange={(e) => handleheaderMapping(head, e.target.value)} />
                          </div>
                        ))
                      }
                    </div>
                  </div>
                  <div className='h75 w75'>
                    <div className='h5 w100 df jc ac'>
                      {
                        valueids.length > 0 && <label>Values Mapping</label>
                      }
                    </div>
                    <div className='h70 w100 of_a'>
                      {
                        valueids.length > 0 && valueids.map((val, ind) => (
                          <div className='w40 white' key={ind}>
                            <div className='h4 w100 df ac jb'>
                              <label>{getheadername(val)}</label>
                              <div className='h4 w20 df jc ac'>
                                {
                                  Showvalue === ind ? <FaCaretUp className='h3 w50' onClick={() => (setShowvalue(0))} /> : <FaCaretDown className='h3 w50' onClick={() => (setShowvalue(ind))} />
                                }
                              </div>
                            </div>
                            {
                              Showvalue === ind && <div className='w100'>
                                {
                                  getheadervalue(val).length > 0 && getheadervalue(val).map((option, val1) => (
                                    <div className='h5 w100 df' key={val1}>
                                      <label className='h5 w40'>{option}</label>
                                      <input placeholder={option} className='h3 w60 b1 padleft' value={(ValueMapping && ValueMapping[val] && ValueMapping[val][option]) || ''} onChange={(e) => { handleValueMapping(val, option, e.target.value) }} />
                                    </div>
                                  ))
                                }
                              </div>
                            }

                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
            }
          </div>
          <div className='h8 w100 df jc ac white'>
            {
              Showconfig ?
                <button className='btn green' onClick={handleConfig}>Submit</button> :
                <button className='btn green' onClick={submitmapping}>Submit</button>
            }

          </div>
        </div>
      </div>
      {
        ShowHeaders && <div className='model'>
          <div className='h60 w30 white df fdc ac'>
            <div className='h5 w98 df ac jb'>
              <p>Select Fields</p>
              <div className='h4 w20 df ac'>
                <label className='df gap ac'>
                  <input
                    type="checkbox"
                    checked={allSelected()}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                  Select All
                </label>
              </div>
            </div>
            <div className='h50 w90 of_a'>
              <div className='df fw gap1 ' >
                {
                  fields.length > 0 && fields.map((obj, index) => {
                    const Headername = Config.Value_F;
                    const connectname = Config.Primary_F
                    return (
                      <label
                        key={index} className='df ac w45 gap'>
                        <input
                          type="checkbox"
                          checked={selectedfieldIds.includes(obj[connectname])}
                          onChange={() => handleCheckboxHeader(obj[Headername], obj[connectname])}
                        />
                        {obj[Headername]}
                      </label>
                    )
                  })
                }
              </div>
            </div>
            <div className='h5 w80 df jc ac gap'>
              <button className='btn green' onClick={() => { setShowHeaders(false); setShowFields(true); getoutputfields() }}>Submit</button>
            </div>
          </div>
        </div>
      }
      {
        ShowFields && <div className='model'>
          <div className='h60 w25 white df fdc ac'>
            <div className='h5 w80 df ac jc'>
              <p>Output Fields</p>
            </div>
            <div className='h50 w80 of_a'>
              {
                outputfields.length > 0 && outputfields.map((field, index) =>
                (
                  <div key={index}
                    className='h3 w100 df ac'
                    style={{
                      border: "1px solid #ddd",
                      margin: "4px 0",
                      background: draggedIndex === index ? "#e0f7fa" : "#f9f9f9", // highlight drop target
                      cursor: "move",
                    }}
                    draggable="true"
                    onDragStart={(e) => onDragStart(e, field, index)}
                    onDragOver={onDragOver}
                    onDrop={(e) => onDrop(e, field, index)}
                  >
                    <label className='w80 padleft'>{field}</label>
                    <div className='h3 w20 df je ac'><IoClose className='h2 w50 r cp' onClick={() => removeField(index)} /></div>
                  </div>
                )
                )
              }
            </div>
            <div className='h5 w100 df jc ac gap'>
              <button className='btn green' onClick={submit}>Submit</button>
            </div>
          </div>
        </div>
      }
    </div >
  )
}

export default Config;